import { useEffect } from 'react';
import { Helmet } from 'react-helmet';


const Payment = () => {

    return (
        <>
            <Helmet>
                <title>Payment</title>
            </Helmet>
            {/* start: Secure Checkout page */}
            <div className="min-h-screen gradient-bg-1 p-6 pb-32 overflow-y-auto">
                <div className="max-w-md mx-auto" style={{ opacity: 1, transform: "none" }}>
                    <div className="text-center mb-6">
                        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-lock w-8 h-8 text-primary"
                            >
                                <rect width={18} height={11} x={3} y={11} rx={2} ry={2} />
                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-foreground mb-2">
                            Secure Checkout
                        </h2>
                        <p className="text-foreground/70 text-sm">Complete your subscription</p>
                    </div>
                    <div
                        className="bg-card rounded-3xl p-6 shadow-lg mb-6 border-2 border-primary/20 relative"
                        style={{ opacity: 1 }}
                    >
                        <div className="absolute -top-3 right-4 bg-success text-white px-4 py-1.5 rounded-full text-sm font-bold shadow-lg">
                            60% OFF
                        </div>
                        <div className="flex justify-between items-start mb-4">
                            <div>
                                <h3 className="font-bold text-foreground text-lg">Premium Plan</h3>
                                <p className="text-sm text-muted-foreground">Billed monthly</p>
                            </div>
                            <div className="text-right">
                                <p className="text-sm text-muted-foreground line-through">$50</p>
                                <p className="text-2xl font-bold text-primary">$19.99</p>
                                <p className="text-xs text-muted-foreground">/month</p>
                            </div>
                        </div>
                        <div className="space-y-2 mb-4 pb-4 border-b border-border">
                            <div className="flex items-center gap-2 text-sm text-foreground/80">
                                <span className="text-primary">✓</span>
                                <span>Unlimited texts</span>
                            </div>
                            <div className="flex items-center gap-2 text-sm text-foreground/80">
                                <span className="text-primary">✓</span>
                                <span>120 voice minutes</span>
                            </div>
                            <div className="flex items-center gap-2 text-sm text-foreground/80">
                                <span className="text-primary">✓</span>
                                <span>30 video minutes</span>
                            </div>
                        </div>
                        <div className="text-xs text-muted-foreground space-y-1">
                            <p>Auto-renews monthly. Cancel anytime.</p>
                            <p className="text-primary/80 font-medium">
                                30-day money-back guarantee
                            </p>
                        </div>
                    </div>
                    <div
                        className="bg-card rounded-3xl p-6 shadow-lg mb-6"
                        style={{ opacity: 1 }}
                    >
                        <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-credit-card w-5 h-5 text-primary"
                            >
                                <rect width={20} height={14} x={2} y={5} rx={2} />
                                <line x1={2} x2={22} y1={10} y2={10} />
                            </svg>
                            Payment Method
                        </h3>
                        <p className="text-xs text-muted-foreground mb-4">
                            All payment methods require 18+ age verification
                        </p>
                        <div className="space-y-3 mb-4">
                            <button className="w-full py-4 px-6 rounded-2xl border-2 border-border bg-background text-foreground font-semibold flex items-center justify-center gap-2 hover:bg-secondary transition-colors">
                                <span>Google Pay</span>
                            </button>
                            <button className="w-full py-4 px-6 rounded-2xl bg-[#0070ba] text-white font-semibold flex items-center justify-center gap-2 hover:opacity-90 transition-opacity">
                                <span>PayPal</span>
                            </button>
                            <button className="w-full py-4 px-6 rounded-2xl bg-[#00d632] text-foreground font-semibold flex items-center justify-center gap-2 hover:opacity-90 transition-opacity">
                                <span>Cash App</span>
                            </button>
                            <button className="w-full py-4 px-6 rounded-2xl bg-[#008cff] text-white font-semibold flex items-center justify-center gap-2 hover:opacity-90 transition-opacity">
                                <span>Venmo</span>
                            </button>
                        </div>
                        <div className="relative mb-4">
                            <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-border" />
                            </div>
                            <div className="relative flex justify-center text-xs">
                                <span className="bg-card px-2 text-muted-foreground">
                                    Or pay with card
                                </span>
                            </div>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <label className="text-sm text-foreground/70 mb-2 block">
                                    Card Number
                                </label>
                                <input
                                    type="text"
                                    placeholder="1234 5678 9012 3456"
                                    className="w-full px-4 py-3 rounded-2xl border-2 border-border bg-background text-foreground focus:border-primary outline-none transition-colors"
                                />
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="text-sm text-foreground/70 mb-2 block">
                                        Expiry
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="MM / YY"
                                        className="w-full px-4 py-3 rounded-2xl border-2 border-border bg-background text-foreground focus:border-primary outline-none transition-colors"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm text-foreground/70 mb-2 block">CVC</label>
                                    <input
                                        type="text"
                                        placeholder={123}
                                        className="w-full px-4 py-3 rounded-2xl border-2 border-border bg-background text-foreground focus:border-primary outline-none transition-colors"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-6" style={{ opacity: 1 }}>
                        <div className="flex items-start gap-3">
                            <button
                                type="button"
                                role="checkbox"
                                aria-checked="false"
                                data-state="unchecked"
                                value="on"
                                className="peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                                id="terms"
                            />
                            <label
                                htmlFor="terms"
                                className="text-sm text-foreground/70 leading-relaxed cursor-pointer"
                            >
                                I confirm I am 18+ years old and agree to the{" "}
                                <button
                                    type="button"
                                    className="underline text-primary hover:text-primary/80 transition-colors"
                                >
                                    Terms of Service
                                </button>{" "}
                                and{" "}
                                <button
                                    type="button"
                                    className="underline text-primary hover:text-primary/80 transition-colors"
                                >
                                    Privacy Policy
                                </button>
                                .{" "}
                            </label>
                        </div>
                    </div>
                    <button
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full mb-3"
                        disabled=""
                    >
                        Subscribe Now — <span className="line-through opacity-60 mr-1">$50</span>{" "}
                        $19.99/mo{" "}
                    </button>
                    <p className="text-center text-xs text-muted-foreground mb-3">
                        Cancel anytime. No hidden fees.
                    </p>
                    <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-lock w-3 h-3"
                        >
                            <rect width={18} height={11} x={3} y={11} rx={2} ry={2} />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                        <span>Secure payment powered by Stripe</span>
                    </div>
                </div>
            </div>
            {/* end: Secure Checkout page */}

            {/* <PaymentSuccess /> */}

        </>
    );
}

export default Payment;
